import { RouteObject } from 'react-router';
import { UserPermission } from '../../users/enums/UserPermission';
import EventReporting from '../pages/EventReporting';
import { REPORTING } from './uri';

const routes = (userCan: (permission: UserPermission) => boolean): RouteObject[] => {
  if (!userCan(UserPermission.REPORTING)) {
    return [];
  }

  return [
    {
      path: REPORTING,
      element: <EventReporting />,
    },
  ];
};

export default routes;
